import { SET_SHOW_EDIT_ROOM_MODAL } from './../const';

export default (showEditRoomModal) => {
  return {
    type: SET_SHOW_EDIT_ROOM_MODAL,
    showEditRoomModal: showEditRoomModal
  }
};
